window.TABS = window.TABS || {};

window.TABS.shop = {
    hasCheckedCourseCategories: false,
    hasAddedCollapseCallback: false,

    init: function () {
        TABS.shop.showToggleDescriptionButton();
        if (!this.hasAddedCollapseCallback) {
            document.querySelectorAll('.collapse').forEach(collapseEl => {
                collapseEl.addEventListener('shown.bs.collapse', function () {
                    TABS.shop.init();
                });
            });
            this.hasAddedCollapseCallback = true;
        }
    },

    showToggleDescriptionButton: function () {
        document.querySelectorAll('.toggleable-product-description').forEach(el => {
            let maxHeight = getComputedStyle(el).maxHeight;
            if (maxHeight === 'none') {
                maxHeight = '200px';
            }
            el.style.overflow = 'hidden';
            el.style.maxHeight = 'none';
            const actualHeight = el.clientHeight;
            el.style.maxHeight = maxHeight;
            const maxHeightInt = parseInt(maxHeight.replace('px', ''));
            if (actualHeight > maxHeightInt) {
                el.nextElementSibling.classList.remove('hidden');
            }
        });
    },

    toggleDescription: function (e, btn) {
        e.preventDefault();
        const $btn = btn;
        $btn.parentElement.parentElement.querySelector('.toggleable-product-description').style.maxHeight = 'none';
        $btn.closest('.toggle-product-description').classList.add('hidden');
    },

    hideCourseCategoriesWithoutCourses: function () {
        document.querySelectorAll('.class-select[data-type-id="3"] .product-class-type-select-button').forEach(el => {
            const filterId = el.dataset.filterId;
            const hasCourses = document.querySelectorAll('.product-group-wrapper[data-type-id="3"] .product-group[data-category-id="' + filterId + '"]').length > 0;
            if (!hasCourses) {
                el.remove();
            }
        });
        this.hasCheckedCourseCategories = true;
    },

    expandCourseList: function (e, el) {
        e.preventDefault();
        el.closest('.course-product-group').querySelectorAll('.course-wrapper').forEach(courseWrapper => {
            courseWrapper.classList.remove('hidden');
        });
        el.remove();
    },

    selectProductType: function (e, id) {
        e.preventDefault();
        if (!this.hasCheckedCourseCategories) {
            this.hideCourseCategoriesWithoutCourses();
        }
        document.querySelectorAll('.product-type-select-button').forEach(button => button.classList.remove('active'));
        e.target.classList.add('active');
        document.querySelectorAll('.class-select').forEach(classSelect => classSelect.classList.add('hidden'));
        document.querySelectorAll('.product-select').forEach(productSelect => productSelect.classList.add('hidden'));
        document.querySelector('.class-select[data-type-id="' + id + '"]').classList.remove('hidden');
        document.querySelectorAll('.product-class-type-select-button').forEach(button => button.classList.remove('active'));
        document.querySelectorAll('.product-group, .product-group-wrapper').forEach(group => group.classList.add('hidden'));
        document.querySelectorAll('.product-group-wrapper[data-type-id="' + id + '"], .product-group[data-type-id="' + id + '"]').forEach(group => group.classList.remove('hidden'));
        TABS.shop.showToggleDescriptionButton();
    },

    selectProductTypeAndCategory: function (e, typeId, webCategoryId) {
        e.preventDefault();
        document.querySelectorAll('.product-class-type-select-button').forEach(button => button.classList.remove('active'));
        e.target.classList.add('active');
        document.querySelectorAll('.product-group, .product-group-wrapper').forEach(group => group.classList.add('hidden'));
        document.querySelectorAll('.product-group-wrapper[data-type-id="' + typeId + '"], .product-group[data-type-id="' + typeId + '"][data-category-id="' + webCategoryId + '"]').forEach(group => group.classList.remove('hidden'));
        TABS.shop.showToggleDescriptionButton();
    },

    triggerPurchase: function (e, typeId, classId, productId, isOptima) {
        e.preventDefault();
        if (typeId === 5) {
            if (isOptima) {
                TABS.api.loadOptimaPackage(e, productId, classId);
            } else {
                TABS.api.loadPackage(e, productId, classId, false);
            }
        } else if (typeId === 26) {
            TABS.api.loadBook(e, productId, classId, typeId);
        } else if (typeId === 18) {
            TABS.api.loadElearning(e, productId, classId, typeId);
        } else if (typeId === 4) {
            TABS.api.loadOther(e, productId, classId, typeId);
        }
    }
}